export type JsDate = Date;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const JsDate = Date;
